import { Amplify } from 'aws-amplify';

import type { CognitoRuntimeConfig } from '@/config/env';

type AmplifyConfigurator = Pick<typeof Amplify, 'configure'>;
let configuredSignature: string | undefined;

export function configureCognito(
  config: CognitoRuntimeConfig,
  amplify: AmplifyConfigurator = Amplify,
) {
  const signature = JSON.stringify(config);
  if (configuredSignature === signature) return;
  if (configuredSignature)
    throw new Error('Amplify Auth was already configured with different Cognito identifiers.');
  amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: { email: true },
        signUpVerificationMethod: 'code',
        userAttributes: {
          email: { required: true },
          given_name: { required: true },
          family_name: { required: true },
        },
      },
    },
  });
  configuredSignature = signature;
}

export function resetCognitoConfigurationForTests() {
  configuredSignature = undefined;
}
